import { BaseHubClient } from '.';

export default class HubClient extends BaseHubClient {
}